import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const CASH = "CASH";
export const PIX = "PIX";
export const TED = "TED";
export const DEBIT = "DEBIT";
export const CREDIT = "CREDIT";
export const DISCOUNT = "DISCOUNT";

export const TYPE_ENTRIES = [
    {id: CASH, name: vue.$t('enumerations.type-entry.cash')},
    {id: PIX, name: vue.$t('enumerations.type-entry.pix')},
    {id: TED, name: vue.$t('enumerations.type-entry.ted')},
    {id: DEBIT, name: vue.$t('enumerations.type-entry.debit')},
    {id: CREDIT, name: vue.$t('enumerations.type-entry.credit')},
    {id: DISCOUNT, name: vue.$t('enumerations.type-entry.discount')},
];

export const _getTypeEntryLabel = (typeEntry) => {
    switch (typeEntry) {
        case CASH : return vue.$t('enumerations.type-entry.cash');
        case PIX : return vue.$t('enumerations.type-entry.pix');
        case TED : return vue.$t('enumerations.type-entry.ted');
        case DEBIT: return vue.$t('enumerations.type-entry.debit');
        case CREDIT: return vue.$t('enumerations.type-entry.credit');
        case DISCOUNT: return vue.$t('enumerations.type-entry.discount');
    }
}